/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Hardware_2Inputs */

const en_svr_guidance_hardware_2 = /** @type {(inputs: Svr_Guidance_Hardware_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Did you take a part away from the site?`)
};

const ja_svr_guidance_hardware_2 = /** @type {(inputs: Svr_Guidance_Hardware_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現場から部品を持ち帰りましたか？`)
};

const fr_svr_guidance_hardware_2 = /** @type {(inputs: Svr_Guidance_Hardware_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avez-vous emporté une pièce du site ?`)
};

const de_svr_guidance_hardware_2 = /** @type {(inputs: Svr_Guidance_Hardware_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haben Sie ein Teil vom Standort mitgenommen?`)
};

/**
* | output |
* | --- |
* | "Did you take a part away from the site?" |
*
* @param {Svr_Guidance_Hardware_2Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_hardware_2 = /** @type {((inputs?: Svr_Guidance_Hardware_2Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Hardware_2Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_hardware_2(inputs)
	if (locale === "ja") return ja_svr_guidance_hardware_2(inputs)
	if (locale === "fr") return fr_svr_guidance_hardware_2(inputs)
	return de_svr_guidance_hardware_2(inputs)
});